module.exports = __webpack_public_path__ + "static/media/BLACK_LOGO_ALOHAR.6f901792.svg";